import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "@/components/LocalLink";
import { PRODUCTS } from "@/data/catalog";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const articleImage = (a) =>
  a.image_path ? `${API}/journal/image/${a.id}` : PRODUCTS.find((p) => p.id === a.product_id)?.imageForest;
export const pick = (a, lang) => (lang === "fr" && a.fr?.title ? a.fr : a.en);
export const fmtDate = (iso, lang) =>
  iso ? new Date(iso).toLocaleDateString(lang === "fr" ? "fr-CA" : "en-CA", { year: "numeric", month: "long", day: "numeric" }) : "";

export const usePublished = () => {
  const [articles, setArticles] = useState(null);
  useEffect(() => {
    axios.get(`${API}/journal`).then((r) => setArticles(r.data)).catch(() => setArticles([]));
  }, []);
  return articles;
};

export const setMeta = (title, description) => {
  document.title = title;
  let m = document.querySelector('meta[name="description"]');
  if (!m) {
    m = Object.assign(document.createElement("meta"), { name: "description" });
    document.head.appendChild(m);
  }
  const prev = m.content;
  m.content = description;
  return () => {
    document.title = "Dirty Paws Apothecary — Mushroom Preparations for Dogs";
    m.content = prev;
  };
};

export const ArticleCard = ({ a, lang, large = false }) => {
  const c = pick(a, lang);
  return (
    <Link to={`/journal/${a.slug}`} data-testid={`journal-card-${a.slug}`} className="group block" data-no-translate>
      <div className="relative overflow-hidden rounded-sm border border-[#303B2D]/60 group-hover:border-[#B5A642]/50 transition-colors duration-500">
        <img src={articleImage(a)} alt={c.title} loading="lazy"
          className={`w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03] ${large ? "aspect-[16/9]" : "aspect-[4/3]"}`} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#111A14]/50 to-transparent" />
      </div>
      <p className="mt-4 font-ledger text-[11px] text-[#D3CEC4]/45">{fmtDate(a.published_at, lang)}</p>
      <h3 className={`mt-2 font-display text-[#E8DDC7] group-hover:text-[#B5A642] transition-colors duration-300 leading-snug ${large ? "text-3xl md:text-4xl" : "text-2xl"}`}>{c.title}</h3>
      <p className="mt-2 text-[14px] leading-relaxed text-[#D3CEC4]/60">{c.dek}</p>
    </Link>
  );
};
